export enum CorrespondenceRelationship {
    SPOUSE = 'Spouse',
    DOMESTIC_PARTNER = 'Domestic Partner',
    OTHER = 'Other'
}